const selectors = {
  getIsOpen(store) {
    return store.admin.modal.isOpen;
  },
  getCurrentItem(store) {
    return store.admin.modal.currentItem;
  },
};

export { selectors };